import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import { MyTranslationSetFragmentDoc } from '../../fragments.generated';
import { PromptMediaFragmentDoc } from './courseInstance/operations.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TraineeLibraryItemSidebarQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type TraineeLibraryItemSidebarQuery = { __typename?: 'Query', LibraryItem?: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, description: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, trainingResource?: { __typename?: 'TrainingResource', id: string, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, richTextDocument?: { __typename?: 'RichTextDocument', id: string, content: { __typename?: 'TranslationSet', uuid: string, myTranslation: string } } | null, media?: { __typename?: 'Media', id: number, updatedAt: string, unoptimizedUrl?: string | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } | null } | null } | null } | null };


export const TraineeLibraryItemSidebarDocument = gql`
    query TraineeLibraryItemSidebar($id: UUID!) {
  LibraryItem(id: $id) {
    id
    name {
      ...MyTranslationSet
    }
    description {
      ...MyTranslationSet
    }
    trainingResource {
      id
      publishedVersion {
        id
        type
        richTextDocument {
          id
          content {
            ...MyTranslationSet
          }
        }
        media {
          id
          updatedAt
          ...PromptMedia
        }
      }
    }
  }
}
    ${MyTranslationSetFragmentDoc}
${PromptMediaFragmentDoc}`;

/**
 * __useTraineeLibraryItemSidebarQuery__
 *
 * To run a query within a React component, call `useTraineeLibraryItemSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useTraineeLibraryItemSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTraineeLibraryItemSidebarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTraineeLibraryItemSidebarQuery(baseOptions: Apollo.QueryHookOptions<TraineeLibraryItemSidebarQuery, TraineeLibraryItemSidebarQueryVariables> & ({ variables: TraineeLibraryItemSidebarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TraineeLibraryItemSidebarQuery, TraineeLibraryItemSidebarQueryVariables>(TraineeLibraryItemSidebarDocument, options);
      }
export function useTraineeLibraryItemSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TraineeLibraryItemSidebarQuery, TraineeLibraryItemSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TraineeLibraryItemSidebarQuery, TraineeLibraryItemSidebarQueryVariables>(TraineeLibraryItemSidebarDocument, options);
        }
export type TraineeLibraryItemSidebarQueryHookResult = ReturnType<typeof useTraineeLibraryItemSidebarQuery>;
export type TraineeLibraryItemSidebarLazyQueryHookResult = ReturnType<typeof useTraineeLibraryItemSidebarLazyQuery>;
export type TraineeLibraryItemSidebarQueryResult = Apollo.QueryResult<TraineeLibraryItemSidebarQuery, TraineeLibraryItemSidebarQueryVariables>;